import type { SurveyQuestion } from '../types/survey';

export const QUESTIONS: SurveyQuestion[] = [
  {
    id: 1,
    question: {
      fr: "Avant d’utiliser un produit de nettoyage, quel est le premier réflexe ?",
      ar: 'ما أول خطوة قبل استعمال منتج التنظيف؟',
    },
    answers: [
      { id: 1, text: { fr: 'Lire l’étiquette et les précautions', ar: 'قراءة الملصق واحتياطات الاستعمال' } },
      { id: 2, text: { fr: 'Verser une grande quantité', ar: 'سكب كمية كبيرة' } },
      { id: 3, text: { fr: 'Mélanger avec un autre produit', ar: 'خلطه مع منتج آخر' } },
    ],
    correctAnswer: 1,
    explanation: {
      fr: 'L’étiquette indique les surfaces compatibles, le dosage et les précautions essentielles.',
      ar: 'يوضح الملصق الأسطح المناسبة والجرعة واحتياطات الاستعمال الأساسية.',
    },
    tip: {
      fr: "Gardez toujours l’emballage d’origine à portée de vue.",
      ar: 'احتفظ دائماً بالعبوة الأصلية في مكان واضح.',
    },
  },
  {
    id: 2,
    question: {
      fr: 'Peut-on mélanger deux produits de nettoyage différents ?',
      ar: 'هل يمكن خلط منتجين مختلفين للتنظيف؟',
    },
    answers: [
      { id: 1, text: { fr: "Oui, pour renforcer l’efficacité", ar: 'نعم، لزيادة الفعالية' } },
      { id: 2, text: { fr: "Seulement s’ils ont la même couleur", ar: 'فقط إذا كان لهما نفس اللون' } },
      { id: 3, text: { fr: 'Non, sauf indication explicite du fabricant', ar: 'لا، إلا إذا سمحت تعليمات الشركة بذلك صراحة' } },
    ],
    correctAnswer: 3,
    explanation: {
      fr: "Certains mélanges peuvent produire des vapeurs dangereuses ou réduire l’efficacité des produits.",
      ar: 'قد تنتج بعض الخلطات أبخرة خطرة أو تقلل من فعالية المنتجات.',
    },
    tip: {
      fr: "Utilisez un seul produit à la fois et rincez si nécessaire avant d’en changer.",
      ar: 'استعمل منتجاً واحداً في كل مرة واشطف السطح عند الحاجة قبل تغييره.',
    },
  },
  {
    id: 3,
    question: {
      fr: 'Où faut-il conserver les produits ménagers ?',
      ar: 'أين يجب حفظ منتجات التنظيف المنزلية؟',
    },
    answers: [
      { id: 1, text: { fr: 'Sous l’évier, sans fermeture', ar: 'تحت المغسلة دون إغلاق' } },
      { id: 2, text: { fr: 'En hauteur ou dans un placard fermé', ar: 'في مكان مرتفع أو خزانة مغلقة' } },
      { id: 3, text: { fr: 'À côté des aliments', ar: 'بجانب المواد الغذائية' } },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "Un rangement fermé et hors de portée réduit les risques d’ingestion et de contact accidentel.",
      ar: 'يقلل الحفظ في خزانة مغلقة وبعيدة عن المتناول من مخاطر الابتلاع أو التلامس العرضي.',
    },
    tip: {
      fr: 'Ne transvasez jamais un produit ménager dans une bouteille alimentaire.',
      ar: 'لا تنقل أبداً منتج تنظيف إلى قارورة مخصصة للمشروبات أو الطعام.',
    },
  },
  {
    id: 4,
    question: {
      fr: 'Quelle quantité de produit faut-il utiliser ?',
      ar: 'ما الكمية المناسبة من منتج التنظيف؟',
    },
    answers: [
      { id: 1, text: { fr: "La dose recommandée sur l’étiquette", ar: 'الجرعة الموصى بها على الملصق' } },
      { id: 2, text: { fr: 'Le plus possible', ar: 'أكبر كمية ممكنة' } },
      { id: 3, text: { fr: 'Toujours la moitié du flacon', ar: 'دائماً نصف العبوة' } },
    ],
    correctAnswer: 1,
    explanation: {
      fr: 'Respecter le dosage permet de nettoyer efficacement tout en limitant les résidus et le gaspillage.',
      ar: 'احترام الجرعة يضمن تنظيفاً فعالاً مع تقليل البقايا والهدر.',
    },
    tip: {
      fr: 'Plus de produit ne signifie pas nécessairement plus de propreté.',
      ar: 'زيادة الكمية لا تعني بالضرورة نظافة أفضل.',
    },
  },
  {
    id: 5,
    question: {
      fr: 'Que faire si un produit éclabousse les yeux ?',
      ar: 'ماذا تفعل إذا وصل المنتج إلى العينين؟',
    },
    answers: [
      { id: 1, text: { fr: 'Attendre quelques minutes', ar: 'الانتظار لبضع دقائق' } },
      { id: 2, text: { fr: "Rincer immédiatement et abondamment à l’eau", ar: 'الشطف فوراً وبغزارة بالماء' } },
      { id: 3, text: { fr: 'Essuyer avec un chiffon sec', ar: 'المسح بقطعة قماش جافة' } },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'Un rinçage immédiat et prolongé aide à éliminer le produit et à limiter l’irritation.',
      ar: 'يساعد الشطف الفوري والمطول على إزالة المنتج وتقليل التهيج.',
    },
    tip: {
      fr: "Consultez l’étiquette et contactez un professionnel de santé si l’irritation persiste.",
      ar: 'راجع الملصق واتصل بمختص صحي إذا استمر التهيج.',
    },
  },
  {
    id: 6,
    question: {
      fr: 'Pourquoi faut-il aérer pendant et après le nettoyage ?',
      ar: 'لماذا يجب تهوية المكان أثناء التنظيف وبعده؟',
    },
    answers: [
      { id: 1, text: { fr: 'Pour faire sécher plus vite uniquement', ar: 'فقط لتجفيف السطح بسرعة' } },
      { id: 2, text: { fr: "Pour renouveler l’air et limiter les vapeurs", ar: 'لتجديد الهواء وتقليل الأبخرة' } },
      { id: 3, text: { fr: "Ce n’est jamais nécessaire", ar: 'لا حاجة لذلك أبداً' } },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "La ventilation renouvelle l’air ambiant et contribue à réduire l’exposition aux odeurs et aux vapeurs.",
      ar: 'تجدد التهوية هواء المكان وتساعد على تقليل التعرض للروائح والأبخرة.',
    },
    tip: {
      fr: 'Ouvrez une fenêtre ou une porte lorsque les conditions le permettent.',
      ar: 'افتح نافذة أو باباً كلما سمحت الظروف بذلك.',
    },
  },
  {
    id: 7,
    question: {
      fr: 'Quel accessoire protège le mieux les mains sensibles ?',
      ar: 'ما الوسيلة الأنسب لحماية اليدين الحساستين؟',
    },
    answers: [
      { id: 1, text: { fr: 'Des gants adaptés', ar: 'قفازات مناسبة' } },
      { id: 2, text: { fr: 'Une serviette en papier', ar: 'منشفة ورقية' } },
      { id: 3, text: { fr: 'Aucun accessoire', ar: 'لا حاجة لأي وسيلة حماية' } },
    ],
    correctAnswer: 1,
    explanation: {
      fr: "Des gants adaptés limitent le contact direct avec l’eau, les salissures et le produit.",
      ar: 'تقلل القفازات المناسبة من التلامس المباشر مع الماء والأوساخ والمنتج.',
    },
    tip: {
      fr: 'Retirez les gants sans toucher leur surface extérieure, puis lavez-vous les mains.',
      ar: 'انزع القفازات دون لمس سطحها الخارجي ثم اغسل يديك.',
    },
  },
  {
    id: 8,
    question: {
      fr: 'Après le nettoyage d’une surface alimentaire, que faut-il vérifier ?',
      ar: 'بعد تنظيف سطح يلامس الطعام، ماذا يجب التحقق منه؟',
    },
    answers: [
      { id: 1, text: { fr: "Qu’il reste une couche visible de produit", ar: 'بقاء طبقة ظاهرة من المنتج' } },
      { id: 2, text: { fr: 'Que les consignes de rinçage ont été respectées', ar: 'احترام تعليمات الشطف' } },
      { id: 3, text: { fr: 'Que le produit a changé de couleur', ar: 'تغير لون المنتج' } },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'Les surfaces en contact avec les aliments doivent être traitées conformément aux indications du produit, notamment pour le rinçage.',
      ar: 'يجب التعامل مع الأسطح الملامسة للطعام وفق تعليمات المنتج، خصوصاً ما يتعلق بالشطف.',
    },
    tip: {
      fr: "Consultez toujours les pictogrammes et les indications d’usage.",
      ar: 'راجع دائماً الرموز وتعليمات الاستعمال.',
    },
  },
];
